'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _rawJsCategories = require('../configs/rawJsCategories');

var rawJsCategories = _interopRequireWildcard(_rawJsCategories);

var _pageTypes = require('../configs/pageTypes');

var pageTypes = _interopRequireWildcard(_pageTypes);

var _transformPx = require('./transformPx');

var _transformPx2 = _interopRequireDefault(_transformPx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getPropValue = function getPropValue(_ref) {
    var transformPx = _ref.transformPx,
        value = _ref.value,
        pageType = _ref.pageType;

    if (transformPx) {
        if (pageType === pageTypes.LANDING_PAGE) {
            return (0, _transformPx2.default)(value);
        }
        return (0, _transformPx2.default)(value, 320 / 375);
    }
    return value;
};

/**
 *
 * @param componentProps
 * @param valueKey 'default' or 'value'
 * @param pageType 'EDIT' or 'LADING_PAGE'
 * @returns {*}
 */

exports.default = function (componentProps, valueKey, pageType) {
    var trackAttr = {};
    var props = componentProps.reduce(function (acc, prop) {
        if (prop.category === rawJsCategories.TRACK) {
            trackAttr[prop.name] = prop[valueKey];
            return acc;
        } else {
            var value = getPropValue({ transformPx: prop.transformPx, value: prop[valueKey], pageType: pageType });
            return _extends({}, acc, _defineProperty({}, prop.name, value));
        }
    }, {});
    props.trackAttr = trackAttr;
    return props;
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/formatConfigsToComponentProps.js
// module id = 230
// module chunks = 0